<template>
  <div class="robot-template">
    <el-row class="dialogItem">
      <span>角色性别</span>
      <el-select v-model="robotData.sex" style="width: 400px" placeholder="请选择" @input="changeDate" clearable>
        <el-option key="-1" label="全部" :value="-1"> </el-option>
        <el-option key="0" label="女性" :value="0"> </el-option>
        <el-option key="1" label="男性" :value="1"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>自定义ID</span>
      <el-input type="text" v-model="robotData.userGroup" style="width: 400px"></el-input>
    </el-row>
    <el-row class="dialogItem">
      <span>主播等级</span>
      <el-select v-model="robotData.appraiseLevel[0]" style="width: 180px; margin-right: 10px" placeholder="请选择"
        @input="changeDate" clearable>
        <el-option key="全部" label="全部" value=""> </el-option>
        <el-option key="L0" label="L0" :value="0"> </el-option>
        <el-option key="L1" label="L1" :value="1"> </el-option>
        <el-option key="L2" label="L2" :value="2"> </el-option>
        <el-option key="L3" label="L3" :value="3"> </el-option>
      </el-select>
      <span class="to"> ~ </span>
      <el-select v-model="robotData.appraiseLevel[1]" style="width: 180px" placeholder="请选择" @input="changeDate"
        clearable>
        <el-option key="全部" label="全部" value=""> </el-option>
        <el-option key="L0" label="L0" :value="0"> </el-option>
        <el-option key="L1" label="L1" :value="1"> </el-option>
        <el-option key="L2" label="L2" :value="2"> </el-option>
        <el-option key="L3" label="L3" :value="3"> </el-option>
      </el-select>
    </el-row>
    <el-row class="dialogItem">
      <span>是否有离线视频</span>
      <el-select v-model.number="robotData.hadOfflineVideo" style="width: 400px" placeholder="请选择" @input="changeDate"
        clearable>
        <el-option key="1" label="有" :value="1"> </el-option>
        <el-option key="2" label="没有" :value="2"> </el-option>
      </el-select>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'RobotTemplate',
  props: {
    robotData: {
      type: Object,
      default: () => ({
        sex: '',
        userGroup: '',
        appraiseLevel: ['', ''],
        hadOfflineVideo: '',
      })
    }
  },
  methods: {
    changeDate() {
      this.$emit('changeDate')
    }
  }
}
</script>

<style scoped lang="scss">
.dialogItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  text-align: left;
  padding-left: 50px;
  color: #000;

  >span {
    width: 160px;
    margin-right: 10px;
    text-align: right;
    font-size: 15px;
    font-weight: bold;

    &.to {
      width: 50px;
      text-align: center;
    }
  }
}
</style> 